export const capitalize = (str: string | undefined): string => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const unCapitalize = (str: string): string => {
  return str.charAt(0).toLowerCase() + str.slice(1);
};

export const trim = (str: string): string => {
  return str.trim().replace(/\s+/g, ' ');
};

export const normalizeText = (text: string): string => {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
};
